import { Navigate, useRoutes } from "react-router-dom";

import Layout from "./Layout/Layout";
import BookNow from "./components/BookNow";
import Payment from "./components/Payment";

const Router = () => {
  return useRoutes([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <BookNow />,
        },
        {
          path: "/payment",
          element: <Payment />,
        },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
};

export default Router;
